/**
 * Configurator cart lock
 * ----------------------
 * Signature Pergola configurations are sold as a set: a structure plus its
 * accessories, each a separate line item that shares one `configurator.build_number`.
 * The customer must not be able to remove a single accessory (e.g. the wind
 * screen) and check out with an incomplete, mispriced build.
 *
 * The Liquid templates lock the quantity inputs and render a single "Remove"
 * control per configuration that carries `data-configurator-remove` and
 * `data-configurator-group="<build_number>"`. This script handles that control:
 * it removes every line item in the group together, then refreshes the cart.
 *
 * NOTE: this is a storefront-UX guard, not a hard server-side guarantee. It is
 * delegated on `document` so it survives Dawn's AJAX cart re-renders.
 */
(function () {
  'use strict';

  // The script is referenced by both the cart page (main-cart-items) and the
  // cart drawer, so on the cart page it can be injected twice. Without this
  // guard each copy registers its own delegated click listener and the
  // confirm() dialog fires once per listener (the "popup shows twice" bug).
  if (window.__configuratorCartLockInit) return;
  window.__configuratorCartLockInit = true;

  var REMOVE_SELECTOR = '[data-configurator-remove]';
  var GROUP_ATTR = 'data-configurator-group';

  function lineKeysForGroup(group) {
    var rows = document.querySelectorAll('[' + GROUP_ATTR + '="' + cssEscape(group) + '"]');
    var keys = [];
    rows.forEach(function (row) {
      var key = row.getAttribute('data-line-key');
      if (key && keys.indexOf(key) === -1) keys.push(key);
    });
    return keys;
  }

  // CSS.escape isn't available in every supported browser; build numbers are
  // alphanumeric (e.g. SP-HVCK5ESR) so a conservative escape is enough.
  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function removeGroup(group, trigger) {
    var keys = lineKeysForGroup(group);
    if (!keys.length) return;

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    if (trigger) trigger.setAttribute('disabled', 'disabled');

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed: ' + response.status);
        return response.json();
      })
      .then(function () {
        // Full reload is the most robust way to re-sync every cart surface
        // (drawer, cart page, header bubble, totals) after a multi-line change.
        window.location.reload();
      })
      .catch(function (error) {
        if (trigger) trigger.removeAttribute('disabled');
        // eslint-disable-next-line no-console
        console.error('[configurator-cart-lock] failed to remove configuration', error);
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(REMOVE_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var group = trigger.getAttribute(GROUP_ATTR);
    if (!group) return;

    var confirmed = window.confirm(
      'Remove the entire Signature Pergola configuration? Its structure and all accessories are sold as a set and will be removed together.'
    );
    if (!confirmed) return;

    removeGroup(group, trigger);
  });
})();
